import React from "react";
import { Typography, List, ListItem, Container, Box } from "@mui/material";
import CustomHelmet from "../../common/CustomHelmet";

const OnlineSexualAddiction = () => {
  return (
    <>
      <CustomHelmet
        title="Online Sex Addiction Counseling - Dr. Anne Rothenberg, Orlando"
        description="Get confidential online counseling for sexual addiction with Dr. Anne Rothenberg, a licensed specialist in Orlando."
        keywords="sexual addiction counseling, pornography addiction help, sex therapy Orlando, cybersex treatment"
        ogTitle="Online Sex Addiction Counseling - Dr. Anne Rothenberg, Orlando"
        ogDescription="Professional and confidential online counseling for sexual addiction with Dr. Anne Rothenberg."
        ogUrl="https://drannerothenberg.com/services/online-sexual-addiction"
      />

      <Container maxWidth="md">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "left",
            textAlign: "left",
            padding: "20px",
            borderRadius: "8px",
          }}
        >
          <Typography variant="h4" gutterBottom>
            Counseling for Compulsive Sexual Behavior & Pornography Concerns
          </Typography>

          <Typography
            variant="subtitle1"
            gutterBottom
            sx={{ color: "#555", mb: 3 }}
          >
            If sexual thoughts or behaviors are controlling your life rather
            than enhancing it, Dr. Anne Rothenberg provides compassionate,
            judgment-free counseling. Whether you're struggling personally or
            concerned about your partner's behavior, there is hope for healing
            and recovery. You don't have to face this alone.
          </Typography>

          <Typography
            variant="body1"
            sx={{
              mb: { xs: 2, md: 3 },
              fontStyle: "italic",
              color: "#666",
              fontSize: { xs: "0.9rem", md: "1rem" },
              padding: { xs: "12px", md: "16px" },
              backgroundColor: "rgba(228, 181, 162, 0.05)",
              borderRadius: "8px",
              borderLeft: "4px solid #E4B5A2",
            }}
          >
            Important: While terms like "sex addiction" are commonly used, the
            clinical term is Compulsive Sexual Behavior Disorder (CSBD). What
            matters most is not the label, but finding help for behaviors that
            are causing distress in your life.
          </Typography>

          <Typography
            variant="h6"
            gutterBottom
            sx={{ color: "#4A90E2", mt: 3 }}
          >
            "I Can't Stop" - When Sexual Behavior Feels Out of Control
          </Typography>
          <List
            dense
            sx={{
              listStyleType: "disc",
              pl: 4,
              color: "#333",
              textAlign: "left",
              mb: 3,
            }}
          >
            <ListItem sx={{ display: "list-item" }}>
              "I promise myself I'll stop, but I always go back"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "I've tried deleting everything, but I just download it again"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "The urges are so strong, I feel powerless"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "I spend hours online when I should be working/sleeping"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "I'm constantly thinking about my next opportunity"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "I've missed important events because of this"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "It started as stress relief, now it controls me"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "I feel like I'm living a double life"
            </ListItem>
          </List>

          <Typography
            variant="h6"
            gutterBottom
            sx={{ color: "#4A90E2", mt: 3 }}
          >
            The Hidden Emotional Cost
          </Typography>
          <List
            dense
            sx={{
              listStyleType: "disc",
              pl: 4,
              color: "#333",
              textAlign: "left",
              mb: 3,
            }}
          >
            <ListItem sx={{ display: "list-item" }}>
              "The shame is crushing - I hate myself afterward"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "I'm constantly anxious someone will find out"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "I feel like a hypocrite in my daily life"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "The guilt is eating me alive"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "I'm depressed about who I've become"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "I feel completely alone with this problem"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "I'm terrified of being exposed"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "I don't recognize myself anymore"
            </ListItem>
          </List>

          <Typography
            variant="h6"
            gutterBottom
            sx={{ color: "#4A90E2", mt: 3 }}
          >
            Impact on Relationships
          </Typography>
          <List
            dense
            sx={{
              listStyleType: "disc",
              pl: 4,
              color: "#333",
              textAlign: "left",
              mb: 3,
            }}
          >
            <ListItem sx={{ display: "list-item" }}>
              "My partner feels betrayed and says it's like cheating"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "They think they're not enough for me"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "I've lost all interest in real intimacy"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "My partner caught me and now there's no trust"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "I choose porn over sex with my partner"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "The lying is destroying our relationship"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "My expectations have become completely unrealistic"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "I can't perform without thinking about porn"
            </ListItem>
          </List>

          <Typography
            variant="h6"
            gutterBottom
            sx={{ color: "#4A90E2", mt: 3 }}
          >
            Life Consequences
          </Typography>
          <List
            dense
            sx={{
              listStyleType: "disc",
              pl: 4,
              color: "#333",
              textAlign: "left",
              mb: 3,
            }}
          >
            <ListItem sx={{ display: "list-item" }}>
              "I've been warned at work about inappropriate internet use"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "I'm spending money we don't have"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "My productivity has crashed"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "I'm exhausted from staying up all night"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "I've isolated myself from friends and family"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "I'm neglecting my responsibilities"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "I'm taking dangerous risks"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "My kids have almost caught me"
            </ListItem>
          </List>

          <Typography
            variant="h6"
            gutterBottom
            sx={{ color: "#4A90E2", mt: 3 }}
          >
            For Partners: "I Don't Know What to Do"
          </Typography>
          <List
            dense
            sx={{
              listStyleType: "disc",
              pl: 4,
              color: "#333",
              textAlign: "left",
              mb: 3,
            }}
          >
            <ListItem sx={{ display: "list-item" }}>
              "I feel like I'm not attractive enough"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "The betrayal feels like an affair"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "I don't know if I can trust them again"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "Should I monitor their devices?"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "I'm angry, hurt, and confused"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "Is this my fault somehow?"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "I need support too"
            </ListItem>
          </List>

          <Typography
            variant="h6"
            gutterBottom
            sx={{ color: "#4A90E2", mt: 4 }}
          >
            The Path to Recovery: What Treatment Looks Like
          </Typography>

          <Typography variant="body1" sx={{ mb: 2 }}>
            Recovery is possible. Dr. Rothenberg uses evidence-based approaches
            tailored to your specific situation:
          </Typography>

          <List
            dense
            sx={{
              listStyleType: "disc",
              pl: 4,
              color: "#333",
              textAlign: "left",
              mb: 3,
            }}
          >
            <ListItem sx={{ display: "list-item" }}>
              <strong>Understanding Your Triggers:</strong> Identifying what
              drives the behavior - stress, loneliness, boredom, or emotional
              pain
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <strong>Developing Healthy Coping Skills:</strong> Learning new
              ways to manage difficult emotions without turning to sexual
              behavior
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <strong>Addressing Underlying Issues:</strong> Working through
              depression, anxiety, trauma, or relationship problems that fuel
              the behavior
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <strong>Rebuilding Relationships:</strong> Healing trust and
              intimacy with your partner (if applicable)
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <strong>Creating Accountability:</strong> Building support systems
              and practical strategies to maintain recovery
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <strong>Shame Reduction:</strong> Moving from self-hatred to
              self-compassion and healing
            </ListItem>
          </List>

          <Typography
            variant="h6"
            gutterBottom
            sx={{ color: "#4A90E2", mt: 3 }}
          >
            Common Concerns About Getting Help
          </Typography>

          <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
            "Will you judge me?"
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, pl: 2 }}>
            No. This is a safe, confidential space. Many people struggle with
            these issues - you're not alone or "perverted."
          </Typography>

          <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
            "Do I have to quit sex forever?"
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, pl: 2 }}>
            No. The goal is healthy sexuality, not abstinence. We work toward
            balanced, fulfilling sexual expression.
          </Typography>

          <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
            "Can this really be treated?"
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, pl: 2 }}>
            Yes. With commitment and the right support, people do recover and
            build healthier lives.
          </Typography>

          <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
            "What if I'm not ready to stop completely?"
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, pl: 2 }}>
            We start where you are. Even reducing harm and gaining more control
            is progress.
          </Typography>

          <Typography
            variant="body1"
            sx={{ mt: 3, fontWeight: "bold", color: "#4A90E2" }}
          >
            Your courage to seek help is the beginning of transformation.
          </Typography>
        </Box>
      </Container>
    </>
  );
};

export default OnlineSexualAddiction;
